
export default {
  submitText: '提交',
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
      column: [
        {
          label: "项目名称",
          prop: "projectId",
          cascaderItem: ['userIds'],
          type: 'tree',
          dicUrl: '/api/v4ward/project/getProjectList',
          props: { label: 'name', value: 'id' },
          rules: [{
            required: true,
            message: "请选择项目名称",
            trigger: "change"
          }]
        },
        {
          label: "计划名称",
          prop: "name",
          maxlength: 30,
          showWordLimit: true,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入计划名称",
            trigger: "blur"
          }]
        },

        {
          label: "合格比例(%)",
          prop: "criterionScore",
          maxlength: 6,
          showWordLimit: true,
          rules: [
            { pattern: /^([0-9]{1,2}|100)$/, message: '请输入0-100的整数' },
            {
              required: true,
              message: "请输入合格比例(%)",
              trigger: "blur"
            }]

        },
        {
          label: "计算类型",
          prop: "calculateType",
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=calculate_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [{
            required: true,
            message: "请选择计算类型",
            trigger: "blur"
          }]
        },
        {
          label: "考核班组",
          prop: "groupName",
          maxlength: 30,
          showWordLimit: true,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入考核班组",
            trigger: "blur"
          }]
        },
   
        {
          label: "考核对象",
          prop: "serviceType",
          type: "select",
          search: true,
          dataType: 'string',
          // dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
          dicData: [],
          props: {
            label: "dictValue",
            value: "dictKey",
          },
          rules: [{
            required: true,
            message: "请选择考核对象",
            trigger: "blur"
          }]
        },
        {
          label: "考核人员",
          prop: "userIds",
          formslot:true,
          // type: "tree",
          // multiple: true,
          // dicUrl: '/api/v4ward/user/project-user-list?projectId={{projectId}}',
          // props: { label: 'realName', value: 'id' },
          rules: [{
            required: true,
            message: "请选择考核人员",
            trigger: "change"
          }]
        },
        {
          label: "通知方式",
          prop: "systemNotifyWays",
          formslot: true,
          rules: [{
            required: true,
            message: "请选择通知方式",
            trigger: "blur"
          }]
        },
        {
          label: "关联合同",
          prop: "contractId",
          type: "tree",
          dataType: 'string',
          dicData: [],
          props: {
            label: "contractName",
            value: "contractId",
          },
        },
        {
          prop: 'test',
          label: '考核内容',
          formslot: true,
          labelslot: true,
          span: 24,
          row: true,
        },
      ]
    },
  ],
};
